var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.142,
    height: 38.179,
    viewBox: "0 0 32.142 38.179",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-xls-4147173",
    transform: "translate(-163.35 -57.452)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46026",
    "data-name": "Path 46026",
    d: "M233.911,68.513h-.241l.241-.034h0a1.134,1.134,0,0,0-.309-.641L223.567,57.809a1.073,1.073,0,0,0-.183-.15l-.048-.029a1.771,1.771,0,0,0-.159-.087l-.087-.024a.681.681,0,0,0-.14-.043,1.292,1.292,0,0,0-.236-.024h-16.1a1.205,1.205,0,0,0-1.205,1.205V71.618a1.205,1.205,0,0,0,2.411,0V59.877h13.694v8.746a1.21,1.21,0,0,0,1.2,1.205l8.8.048V93.22h-23.7V91.354a1.205,1.205,0,1,0-2.411,0v3.071a1.206,1.206,0,0,0,1.205,1.205h26.11a1.206,1.206,0,0,0,1.205-1.205V68.677a.99.99,0,0,0-.014-.164Zm-9.991-1.09V61.584l5.873,5.868Z",
    transform: "translate(-38.433 0)",
    fill: "#0055af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46027",
    "data-name": "Path 46027",
    d: "M188.9,252.79H164.555A1.205,1.205,0,0,0,163.35,254v12.021a1.205,1.205,0,0,0,1.205,1.205H188.9a1.205,1.205,0,0,0,1.205-1.205V254a1.205,1.205,0,0,0-1.205-1.205Zm-16.283,10.675v-.043l-1.172-2.184-1.225,2.228h-1.635l1.986-3.308-1.982-3.578H170.3l.024.048,1.172,2.324,1.22-2.372h1.61l-1.986,3.515,1.992,3.375Zm6.268,0h-3.968v-6.886h1.529v5.511h2.464Zm4.446-.444h0a2.6,2.6,0,0,1-1.731.564,9.479,9.479,0,0,1-1.929-.241l-.429-.082.159-1.22h.082a16.847,16.847,0,0,0,2.016.179c.651,0,.964-.26.964-.786a.483.483,0,0,0-.149-.419,3.464,3.464,0,0,0-.965-.371,4.047,4.047,0,0,1-1.654-.8,1.742,1.742,0,0,1-.482-1.312,1.894,1.894,0,0,1,.646-1.567,2.69,2.69,0,0,1,1.731-.511,11.01,11.01,0,0,1,1.876.2l.434.082-.14,1.239h-.087c-.921-.1-1.581-.154-1.957-.154-.993,0-.993.482-.993.627a.482.482,0,0,0,.227.41,6.736,6.736,0,0,0,1.234.482,3.554,3.554,0,0,1,1.413.738,1.758,1.758,0,0,1,.419,1.287,2.068,2.068,0,0,1-.661,1.654Z",
    transform: "translate(0 -178.519)",
    fill: "#0055af"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXls);
export default __webpack_public_path__ + "static/media/xls.633b1aac78db945eda3ac11fecf8ada5.svg";
export { ForwardRef as ReactComponent };